module.exports = __webpack_public_path__ + "341ab5f2d8d24d76691f4796ecf90996.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/6_F2.mp3
// module id = 103
// module chunks = 0